// extracted by mini-css-extract-plugin
export default {"wrapper":"Divider_wrapper__rgXx6"};